import React from 'react';
import classNames from 'classnames';
import { Link, matchPath, useLocation } from 'react-router-dom';
import { parse, stringify } from 'query-string';

export const NavLink = props => {
  const {
    activeClass = 'active',
    activePath,
    backTrack = false,
    children,
    className,
    end = false,
    to,
    ...rest
  } = props;

  const { pathname, search } = useLocation();
  const { backLabel, backPath } = parse(search);
  const path = activePath || to;
  // if the NavLink was passed backTrack we don't use backPath to check active
  // because we should in the context of a nested page.
  const checkedPath = backTrack ? pathname : backPath || pathname;
  const match = matchPath({ path, end }, decodeURIComponent(checkedPath));
  const isActive = !!match;
  return (
    <Link
      replace={match && path === match.pathname}
      className={classNames(className, { [activeClass]: isActive })}
      to={backTrack ? `${to}?${stringify({ backLabel, backPath })}` : to}
      {...rest}
    >
      {children}
    </Link>
  );
};
